<div class="h-100 d-flex justify-content-around align-items-center gap-0_5">
    <i class="cp icon-edit" (click)="onClick('edit')" tooltip="Edit"></i>
    <i class="cp far fa-trash-alt" (click)="onClick('delete')" tooltip="Delete"></i>
</div>
